// extracted by mini-css-extract-plugin
export default {"search__filters":"styles_search__filters__Ow1qr"};